import * as React from 'react'

const SvgTutrosDashboardIcon = ({ stroke }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11.3999V15.3999M14 9.3999V15.3999M10 5.3999V15.3999M5.8 19.3999H14.2C15.8802 19.3999 16.7202 19.3999 17.362 19.0729C17.9265 18.7853 18.3854 18.3264 18.673 17.7619C19 17.1201 19 16.2801 19 14.5999V6.1999C19 4.51974 19 3.67967 18.673 3.03793C18.3854 2.47344 17.9265 2.0145 17.362 1.72688C16.7202 1.3999 15.8802 1.3999 14.2 1.3999H5.8C4.11984 1.3999 3.27976 1.3999 2.63803 1.72688C2.07354 2.0145 1.6146 2.47344 1.32698 3.03793C1 3.67967 1 4.51974 1 6.1999V14.5999C1 16.2801 1 17.1201 1.32698 17.7619C1.6146 18.3264 2.07354 18.7853 2.63803 19.0729C3.27976 19.3999 4.11984 19.3999 5.8 19.3999Z"
      stroke={stroke ? stroke : '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgTutrosDashboardIcon
